/* eslint-disable */
export const convertMonth = (monthNumber) => {
  switch (monthNumber) {
    case 1:
    case '01':
      return 'فروردین'
      break
    case 2:
    case '02':
      return 'اردیبهشت'
      break
    case 3:
    case '03':
      return 'خرداد'
      break
    case 4:
    case '04':
      return 'تیر'
      break
    case 5:
    case '05':
      return 'مرداد'
      break
    case 6:
    case '06':
      return 'شهریور'
      break
    case 7:
    case '07':
      return 'مهر'
      break
    case 8:
    case '08':
      return 'آبان'
      break
    case 9:
    case '09':
      return 'آذر'
      break
    case 10:
    case '10':
      return 'دی'
      break
    case 11:
    case '11':
      return 'بهمن'
      break
    case 12:
    case '12':
      return 'اسفند'
      break
    default:
      return ''
  }
}

export const convertMinuteToHour = (n) => {
  let decimalDobule = 0
  if (n !== null) {
    n = n.toFixed(1)
  }
  let num = n
  let hours = num / 60
  let rhours = Math.floor(hours)
  let withZeroHour = rhours < 10 ? '0' + rhours : rhours
  let minutes = (hours - rhours) * 60
  let rminutes = Math.round(minutes)
  let fixMinuted = minutes.toFixed(decimalDobule)
  let withZero = fixMinuted < 10 ? '0' + fixMinuted : fixMinuted
  return withZero + ' : ' + withZeroHour
}

export const roundTo = (number) => {
  return number.toFixed(2)
}

export const genderType = (gender) => {
  if (gender === 0) {
    return 'مرد'
  } else if (gender === 1) {
    return 'زن'
  } else {
    return 'نا مشخص'
  }
}
